import { FormGroupUI } from "components/FormGroup";
import { FormGroupLabelUI } from "components/FormGroupLabel";
import { RhfCreatableMultiSelect } from "components/rhfs/RhfCreatableMultiSelect";
import { RhfFromToNumberInput } from "components/rhfs/RhfFromToNumberInput";
import { RhfSelect } from "components/rhfs/RhfSelect";
import { RhfSkillAutocomplete } from "components/rhfs/RhfSkillAutocomplete";
import { RhfToggle } from "components/rhfs/RhfToggle";
import {
  INITIAL_MATTER_FILTER,
  limitedDaysOptions,
  matterDistanceFromEndOptions,
  matterOrderTypeOptions,
  REWARD_PRESETS,
} from "constants/search-fiilter";
import type { EmailSearchInput } from "hooks/useEmailsRestApi";
import type { FC } from "react";

export type ChangeEmailSearchInput = (searchInput: EmailSearchInput) => void;
export type ChangeIsMatterHandler = (isMatter: boolean) => void;

export const MatterTypeFormUI: FC = () => {
  return (
    <div className="flex flex-col w-full">
      {/* 左側 */}
      <div className="flex flex-col grow">
        <FormGroupUI className="mb-6">
          <FormGroupLabelUI>期間</FormGroupLabelUI>
          <RhfSelect
            name="limitedByDay"
            width="narrow"
            options={limitedDaysOptions}
          />
        </FormGroupUI>
        {/* 単価 */}
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>単価</FormGroupLabelUI>
          <RhfFromToNumberInput
            testLabel="matter-reward"
            nameFrom="matterFilter.rewardRange.from"
            nameTo="matterFilter.rewardRange.to"
            min={INITIAL_MATTER_FILTER.rewardRange!.from!}
            max={INITIAL_MATTER_FILTER.rewardRange!.to!}
            step={5}
            unitName="万円"
            presets={REWARD_PRESETS}
          />
        </FormGroupUI>
      </div>
      <div className="divider divider-horizontal"></div>
      {/* 中央 */}
      <div className="flex flex-col grow">
        <FormGroupUI className="mb-6">
          <FormGroupLabelUI>並び順</FormGroupLabelUI>
          <RhfSelect
            name="orderType"
            width="narrow"
            options={matterOrderTypeOptions}
          />
        </FormGroupUI>
        <FormGroupUI className="mb-6">
          <FormGroupLabelUI>商流</FormGroupLabelUI>
          <RhfSelect
            name="matterFilter.distanceFromEnd"
            width="narrow"
            options={matterDistanceFromEndOptions}
          />
        </FormGroupUI>
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>スキル</FormGroupLabelUI>
          <RhfSkillAutocomplete
            name="skills"
            placeholder="例: TypeScript, AWS"
          />
        </FormGroupUI>
        <FormGroupUI className="mb-5">
          <FormGroupLabelUI>フリーワード</FormGroupLabelUI>
          <RhfCreatableMultiSelect
            name="freeWords"
            placeholder="例: 会社名, 駅名"
          />
        </FormGroupUI>
      </div>
      <div className="divider divider-horizontal"></div>
      <div className="flex flex-col grow-0 w-full space-y-2.5">
        <RhfToggle
          color="primary"
          label="面談1回"
          name="matterFilter.oneOpportunity"
        />
        <RhfToggle
          color="primary"
          label="外国籍OK"
          name="matterFilter.otherCountriesEnabled"
        />
        <RhfToggle
          color="primary"
          label="個人事業主不可を除く"
          name="matterFilter.onlyEnableFreelance"
        />
        <RhfToggle
          color="primary"
          label="テレワークOK"
          name="matterFilter.enableRemote"
        />
        <RhfToggle
          color="warning"
          label="お気に入りのみ"
          name="favoritesOnly"
        />
      </div>
    </div>
  );
};
